















































































import { Component, Vue, Prop } from "vue-property-decorator";
import PurchaseItemModel from "@/usecases/accounting/purchase-item";
import PurchaseRow from "./PurchaseRow.vue";
import VTd from "./VTd.vue";
import SelectOption from "../../../common/ui/presenters/select-option";

@Component({
  components: {
    VTd,
    PurchaseRow
  }
})
export default class PurchaseItem extends Vue {
  @Prop({ required: true }) item!: PurchaseItemModel;
  @Prop({ default: () => [] }) unitOptions!: SelectOption[];

  change() {
    this.$emit("change");
  }
}
